module.exports = __webpack_public_path__ + "assets/TeamParrots.24bcc289.svg";